import { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Container,
  Row,
  Col,
  Button,
  Table,
  Pagination,
  Form,
} from "react-bootstrap";
import {
  faTrash,
  faUserPlus,
  faTimes,
  faUserEdit,
  faCaretDown,
  faCaretUp,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import { DataService } from "../../shared/services/data.service";
import { NotifierService } from "../../shared/services/notifier.service";
import { SpinnerService } from "../../shared/services/spinner.service";
import { DeleteUserModal } from "./deleteusermodal";
import { AuthenticateService } from "../../security/login/authenticate.service";

interface UserListState {
  filter: {
    name?: string;
    email?: string;
    profileId?: number;
  };
  filterVisible: boolean;
  appliedFilter?: {
    name?: string;
    email?: string;
    profileId?: number;
  };
  pagination: {
    currentPage?: number;
    moreRowsAvailable?: boolean;
  };
  profiles: any[];
  tenants: any[];
  tenantMap: any;
  profileMap: any;
  users: any[];
  deleteButton?: boolean;
  isAnySelected?: boolean;
  show?: boolean;
  deleteUserId?: any;
}

class UsersList extends Component<any, UserListState> {
  constructor(props: any) {
    super(props);
    this.state = {
      filter: {
        name: "",
        email: "",
        profileId: undefined,
      },
      filterVisible: false,
      profiles: [],
      tenants: [],
      tenantMap: {},
      profileMap: {},
      users: [],
      pagination: {
        currentPage: 1,
        moreRowsAvailable: false,
      },
      show: false,
      deleteUserId: undefined,
    };
  }

  updateFilterOption = (event: any) => {
    const target = event.target;
    var value = target.value;
    const name = target.name;
    const filter: any = this.state.filter;
    filter[name] = value;
    this.setState({ filter });
  };

  deleteUsers = async (userId?: any) => {
    SpinnerService.show();
    const users = this.state.users || [];
    for (let i = 0; i < users.length; i++) {
      const user: any = users[i];
      if ((userId && user.userId !== userId) || (!userId && !user.selected)) {
        continue;
      }
      await DataService.delete(`users/${user.userId}`, {});
      this.setState({ show: false });
      NotifierService.success(`User ${user.name} deleted successfully.`);
    }

    this.updateListData(this.state.pagination.currentPage);
  };

  async confirmDelete(userId?: any) {
    this.setState({ show: true, deleteUserId: userId });
  }

  cancel = () => {
    this.setState({ show: false });
  };

  async componentDidMount() {
    SpinnerService.show();
    setTimeout(async () => {
      const profiles = await AuthenticateService.getProfiles();
      const tenants = await AuthenticateService.getTenants();
      const profileMap: any = {};
      const tenantMap: any = {};
      profiles.forEach((profile: any) => {
        profileMap[profile.profileId] = profile;
      });
      tenants.forEach((tenant: any) => {
        tenantMap[tenant.tenantId] = tenant;
      });
      this.setState(
        {
          profiles,
          tenants,
          profileMap,
          tenantMap,
        },
        () => {
          this.updateListData();
        }
      );
    }, 0);
  }

  async updateListData(page?: number) {
    SpinnerService.show();
    page = page || 1;
    const appliedFilter = this.state.appliedFilter;
    let url = `users?order.by=name&MR=10&PN=${page}`;
    if (appliedFilter && appliedFilter.name) {
      url += `&name.like=${appliedFilter.name}`;
    }
    if (appliedFilter && appliedFilter.email) {
      url += `&email.like=${appliedFilter.email}`;
    }
    if (appliedFilter && appliedFilter.profileId) {
      url += `&profileId=${appliedFilter.profileId}`;
    }
    let response = await DataService.getWithHeader(url, {});
    const users = response.data;
    users.forEach((user: any) => {
      const profile = this.state.profileMap[user.profileId];
      if (profile) {
        user.profileName = profile.profileName;
      }
      let tenantId = -1;
      if (user.permissions) {
        user.permissions.forEach((permission: any) => {
          if (
            permission.type === "T" &&
            permission.referenceId &&
            permission.access === "A"
          ) {
            tenantId = parseInt(permission.referenceId);
          }
        });
      }
      const tenant = this.state.tenantMap[tenantId];
      if (tenant) {
        user.tenantName = tenant.tenantName;
      } else {
        user.tenantName = "-";
      }
    });

    const moreRowsAvailable = response.headers["more-rows-available"] === "Y";
    this.setState({
      pagination: {
        currentPage: page,
        moreRowsAvailable,
      },
      users,
    });
    SpinnerService.hide();
  }

  async filterToggle() {
    this.setState({ filterVisible: !this.state.filterVisible });
  }

  async applyFilters() {
    this.setState(
      {
        appliedFilter: { ...this.state.filter },
      },
      () => {
        this.updateListData();
      }
    );
  }

  async clearFilter() {
    this.setState(
      {
        appliedFilter: undefined,
        filter: {
          name: "",
          email: "",
          profileId: undefined,
        },
        filterVisible: false,
      },
      () => {
        this.updateListData();
      }
    );
  }

  selectUser(userId?: number) {
    const users = this.state.users || [];
    const selectedUsers = users.filter((user: any) => user.selected);
    const isAllSelected =
      selectedUsers.length === users.length && users.length > 0;
    users.forEach((user) => {
      if (userId && user.userId !== userId) {
        return;
      }
      if (userId) {
        user.selected = !user.selected;
      } else {
        user.selected = isAllSelected ? false : true;
      }
    });
    this.setState({ users });
  }

  async previousPage() {
    const page: number = (this.state.pagination || {}).currentPage || 1;
    if (page > 1) {
      this.updateListData(page - 1);
    }
  }

  async nextPage() {
    const page: number = (this.state.pagination || {}).currentPage || 1;
    const moreRowsAvailable: boolean =
      (this.state.pagination || {}).moreRowsAvailable || false;
    if (moreRowsAvailable) {
      this.updateListData(page + 1);
    }
  }

  getAppliedFilterText() {
    let text = "";
    const appliedFilter = this.state.appliedFilter;
    if (appliedFilter && appliedFilter.name) {
      text += `Name contains ${appliedFilter.name}`;
    }
    if (appliedFilter && appliedFilter.email) {
      text += `Email contains ${appliedFilter.email}`;
    }
    if (appliedFilter && appliedFilter.profileId) {
      const profile = this.state.profileMap[appliedFilter.profileId];
      if (profile) {
        text += `profile = ${profile.profileName}`;
      }
    }
    return text;
  }

  render() {
    const users = this.state.users || [];
    const selectedUsers = users.filter((user: any) => user.selected);
    const isAnySelected = selectedUsers.length > 0;
    const isAllSelected =
      selectedUsers.length === users.length && users.length > 0;
    const filterText = this.getAppliedFilterText();
    const profiles = this.state.profiles;
    const show = this.state.show;
    const deleteUserId = this.state.deleteUserId;

    return (
      <div className="report-container">
        <Row className="users-title light-background">
          <Col xs={9} className="align-self-center">
            Add/ Delete User Profiles
          </Col>
          <Col xs={3} className="align-end">
            <Button variant="outline-light">
              <Link to="/users/new">
                <FontAwesomeIcon icon={faUserPlus} size="1x" color="#5F5F5F" />
              </Link>
            </Button>
            &nbsp;
            <Button
              variant="outline-light"
              onClick={async () => await this.confirmDelete()}
              className={
                isAnySelected ? "display-inline-block" : "display-none"
              }
            >
              <FontAwesomeIcon icon={faTrash} size="1x" color="#f58585" />
            </Button>
          </Col>
        </Row>
        <Container fluid={true} className="users-scroll">
          <Row className="p-3">
            <Col className="filter-box light-background">
              <Row>
                <Col
                  xs={12}
                  className="center-class filter-header"
                  onClick={() => this.filterToggle()}
                >
                  Filters
                  <span
                    className="filter-text"
                    style={{
                      display:
                        filterText && filterText.length > 0
                          ? "inline-block"
                          : "none",
                    }}
                  >
                    {filterText}
                    &nbsp;
                    <FontAwesomeIcon
                      className="cursor"
                      icon={faTimes}
                      color="#ffaaaa"
                      onClick={() => this.clearFilter()}
                    />
                  </span>
                  <FontAwesomeIcon
                    className="cursor float-right"
                    icon={
                      this.state.filter && this.state.filterVisible
                        ? faCaretUp
                        : faCaretDown
                    }
                    color="lightgray"
                    onClick={async () => this.filterToggle()}
                  />
                </Col>
                <Col
                  xs={12}
                  className={
                    this.state.filterVisible
                      ? "display-block center-class pb-3"
                      : "display-none center-class p-3"
                  }
                >
                  <Form>
                    <Row>
                      <Col>
                        <Form.Control
                          type="text"
                          placeholder="Name"
                          value={this.state.filter.name}
                          name="name"
                          onChange={this.updateFilterOption}
                        />
                      </Col>
                      <Col className="pad-l-none">
                        <Form.Control
                          type="text"
                          placeholder="Email"
                          name="email"
                          value={this.state.filter.email}
                          onChange={this.updateFilterOption}
                        />
                      </Col>
                      <Col className="pad-l-none">
                        <Form.Control
                          as="select"
                          //placeholder="Role"
                          name="profileId"
                          value={this.state.filter.profileId}
                          onChange={this.updateFilterOption}
                        >
                          <option value="0">Role</option>
                          {profiles.map((profile) => (
                            <option
                              key={`filter-${profile.profileId}`}
                              value={profile.profileId}
                            >
                              {profile.profileName}
                            </option>
                          ))}
                        </Form.Control>
                      </Col>
                      <Col>
                        <Row>
                          <div className="col-6 pad-none">
                            <Button
                              className="btn-default btn-primary d-none d-sm-block"
                              title="Apply"
                              value="Apply"
                              onClick={() => this.applyFilters()}
                            >
                              {" "}
                              Apply{" "}
                            </Button>
                            <Button
                              variant="outline-light"
                              title="Apply"
                              className="d-block d-sm-none"
                              onClick={() => this.applyFilters()}
                            >
                              <FontAwesomeIcon
                                icon={faSave}
                                size="1x"
                                color="#5F5F5F"
                              />
                            </Button>
                          </div>
                          <div className="col-6 pad-none">
                            <Button
                              className="btn-non-primary btn-default d-none d-sm-block"
                              title="Cancel"
                              value="Cancel"
                              onClick={() => this.clearFilter()}
                            >
                              {" "}
                              Clear{" "}
                            </Button>
                            <Button
                              variant="outline-light"
                              title="Cancel"
                              className="d-block d-sm-none"
                              onClick={() => this.clearFilter()}
                            >
                              <FontAwesomeIcon
                                icon={faTimes}
                                size="1x"
                                color="#5F5F5F"
                              />
                            </Button>
                          </div>
                        </Row>
                      </Col>
                    </Row>
                  </Form>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="table-scroll">
              <Table responsive>
                <thead>
                  <tr className="light-background">
                    <th className="action-column">
                      <input
                        className="cursor"
                        type="checkbox"
                        id="checkAll"
                        checked={isAllSelected}
                        onChange={() => this.selectUser()}
                      />
                    </th>
                    <th className="action-column"></th>
                    <th className="action-column"></th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Mobile Number</th>
                    <th>Bank</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user, i) => (
                    <tr key={`userlist-${user.userId}`}>
                      <td>
                        <input
                          type="checkbox"
                          className="cursor"
                          onChange={() => this.selectUser(user.userId)}
                          checked={user.selected || false}
                        />
                      </td>
                      <td
                        className="cursor"
                        onClick={() => this.confirmDelete(user.userId)}
                      >
                        <FontAwesomeIcon
                          icon={faTrash}
                          size="1x"
                          color="#f58585"
                        />
                      </td>
                      <td>
                        <Link to={`user/${user.userId}`}>
                          <FontAwesomeIcon
                            icon={faUserEdit}
                            size="1x"
                            color="white"
                          />
                        </Link>
                      </td>
                      <td>{user.name}</td>
                      <td>{user.email}</td>
                      <td>{user.profileName || ""}</td>
                      <td>{user.contactNo}</td>
                      <td>{user.tenantName || ""}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="pr-4">
              <Pagination className="align-end">
                <Pagination.Prev
                  className={
                    (this.state.pagination.currentPage || 1) < 2
                      ? "disabled"
                      : ""
                  }
                  onClick={() => this.previousPage()}
                />
                <Pagination.Item>
                  {this.state.pagination.currentPage || 1}
                </Pagination.Item>
                <Pagination.Next
                  className={
                    !this.state.pagination.moreRowsAvailable ? "disabled" : ""
                  }
                  onClick={() => this.nextPage()}
                />
              </Pagination>
            </Col>
          </Row>
        </Container>
        <DeleteUserModal
          show={show}
          deleteUserId={deleteUserId}
          confirm={this.deleteUsers}
          cancel={this.cancel}
        />
      </div>
    );
  }

  static properties = (state: any) => {
    return {
      updatedUser: state.app.updateList,
    };
  };

  static dispatchers = (dispatch: any) => {
    return {
      updateList: (payload: any) => {
        dispatch({ type: "UPDATED_USER_LIST", payload });
      },
    };
  };
}

export const Users = connect(
  UsersList.properties,
  UsersList.dispatchers
)(withRouter(UsersList));
